import React from 'react';
import { FiAlertTriangle, FiZap } from 'react-icons/fi';

// Modal exibido quando um pagamento por CARTÃO é recusado. Recomenda o Pix
// (que não passa pela análise de risco) e avisa que o cartão pode estar em
// ajustes. Usado na página /produtos (vinda do cadastro ou de uma recusa local).
export default function PagamentoRecusadoModal({ motivo, onClose }) {
    return (
        <div style={s.overlay} role="dialog" aria-modal="true">
            <div style={s.card}>
                <div style={s.iconBox}><FiAlertTriangle size={26} /></div>
                <h3 style={s.titulo}>Pagamento não aprovado</h3>
                <p style={s.texto}>
                    {motivo ? `${motivo} ` : 'Seu cartão foi recusado. '}
                    Recomendamos finalizar a compra pelo <b>Pix</b> — ele é aprovado na
                    hora e não passa pela análise de risco do cartão.
                </p>
                <div style={s.nota}>
                    ℹ️ Nosso pagamento por cartão pode estar passando por ajustes no
                    momento. Se possível, use o Pix para garantir a sua carteirinha.
                </div>
                <button type="button" onClick={onClose} style={s.botao}>
                    <FiZap size={16} /> Entendi, vou pagar com Pix
                </button>
            </div>
        </div>
    );
}

const s = {
    overlay: {
        position: 'fixed', inset: 0, zIndex: 10001,
        background: 'rgba(15,23,42,0.55)', backdropFilter: 'blur(2px)',
        display: 'grid', placeItems: 'center', padding: 20,
    },
    card: {
        width: '100%', maxWidth: 420, background: '#FFFFFF', borderRadius: 16,
        padding: '1.6rem 1.5rem', textAlign: 'center',
        fontFamily: "'Inter','Roboto',system-ui,sans-serif",
        boxShadow: '0 24px 48px -12px rgba(15,23,42,0.3)',
    },
    iconBox: {
        width: 52, height: 52, borderRadius: 14, margin: '0 auto 0.9rem',
        background: 'linear-gradient(135deg, #F59E0B, #F43F5E)', color: '#FFFFFF',
        display: 'grid', placeItems: 'center',
    },
    titulo: { fontSize: '1.2rem', fontWeight: 800, color: '#0F172A', margin: '0 0 0.5rem' },
    texto: { fontSize: '0.92rem', color: '#475569', lineHeight: 1.55, margin: '0 0 1rem' },
    nota: {
        textAlign: 'left', background: '#FFFBEB', border: '1px solid #FCD34D',
        borderRadius: 12, padding: '0.8rem 0.9rem', color: '#92400E',
        fontSize: '0.82rem', lineHeight: 1.5, marginBottom: '1.2rem',
    },
    botao: {
        width: '100%', padding: '0.85rem', borderRadius: 10, border: 'none', cursor: 'pointer',
        background: 'linear-gradient(135deg, #059669, #10B981)', color: '#FFFFFF',
        fontWeight: 700, fontSize: '0.92rem', fontFamily: 'inherit',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
    },
};
